"use strict";

var _interopRequireWildcard = require("@babel/runtime-corejs2/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime-corejs2/helpers/interopRequireDefault");

var _Object$defineProperty2 = require("@babel/runtime-corejs2/core-js/object/define-property");

_Object$defineProperty2(exports, "__esModule", {
  value: true
});

exports["default"] = void 0;

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime-corejs2/core-js/object/define-property"));

var _defineProperties = _interopRequireDefault(require("@babel/runtime-corejs2/core-js/object/define-properties"));

var _getOwnPropertyDescriptors = _interopRequireDefault(require("@babel/runtime-corejs2/core-js/object/get-own-property-descriptors"));

var _getOwnPropertyDescriptor = _interopRequireDefault(require("@babel/runtime-corejs2/core-js/object/get-own-property-descriptor"));

var _getOwnPropertySymbols = _interopRequireDefault(require("@babel/runtime-corejs2/core-js/object/get-own-property-symbols"));

var _keys = _interopRequireDefault(require("@babel/runtime-corejs2/core-js/object/keys"));

var _extends2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/extends"));

var _defineProperty3 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/defineProperty"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/objectWithoutProperties"));

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _rawButton = _interopRequireDefault(require("@paprika/raw-button"));

var _isActiveElementPopover = require("../../helpers/isActiveElementPopover");

var _PopoverContext = _interopRequireDefault(require("../../PopoverContext"));

var sc = _interopRequireWildcard(require("../../Popover.styles"));

function ownKeys(object, enumerableOnly) { var keys = (0, _keys["default"])(object); if (_getOwnPropertySymbols["default"]) { var symbols = (0, _getOwnPropertySymbols["default"])(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return (0, _getOwnPropertyDescriptor["default"])(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { (0, _defineProperty3["default"])(target, key, source[key]); }); } else if (_getOwnPropertyDescriptors["default"]) { (0, _defineProperties["default"])(target, (0, _getOwnPropertyDescriptors["default"])(source)); } else { ownKeys(Object(source)).forEach(function (key) { (0, _defineProperty2["default"])(target, key, (0, _getOwnPropertyDescriptor["default"])(source, key)); }); } } return target; }

var propTypes = {
  /** Descriptive a11y text for assistive technologies for the trigger. */
  a11yText: _propTypes["default"].string,
  children: _propTypes["default"].oneOfType([_propTypes["default"].func, _propTypes["default"].node]).isRequired
};
var defaultProps = {
  a11yText: null
};

function Trigger(props) {
  var _React$useContext = _react["default"].useContext(_PopoverContext["default"]),
      content = _React$useContext.content,
      isEager = _React$useContext.isEager,
      isOpen = _React$useContext.isOpen,
      onClick = _React$useContext.onClick,
      onClose = _React$useContext.onClose,
      onDelayedClose = _React$useContext.onDelayedClose,
      onDelayedOpen = _React$useContext.onDelayedOpen,
      onOpen = _React$useContext.onOpen,
      shouldKeepFocus = _React$useContext.shouldKeepFocus;

  function handleTriggerEvent(event) {
    if (isEager && (event.type === "mouseover" || event.type === "focus")) {
      if (event.type === "mouseover") {
        onDelayedOpen();
      } else {
        onOpen();
      }
    } else if (isEager && event.type === "mouseout") {
      onDelayedClose();
    } else if ((shouldKeepFocus || isEager) && event.type === "blur") {
      window.requestAnimationFrame(function () {
        if (!(0, _isActiveElementPopover.isActiveElementPopover)()) onClose();
      });
    } else if (event.type === "click" || event.key === " " || event.key === "Enter") {
      onClick(event);
    }
  }

  var children = props.children,
      a11yText = props.a11yText,
      moreProps = (0, _objectWithoutProperties2["default"])(props, ["children", "a11yText"]);
  var tooltipA11yProps = {
    "aria-describedby": content.ariaId
  };
  var popoverA11yProps = {
    "aria-haspopup": true,
    "aria-controls": content.ariaId,
    "aria-expanded": isOpen
  };
  var a11yAttributes = isEager ? tooltipA11yProps : popoverA11yProps;

  if (typeof children === "function") {
    return /*#__PURE__*/_react["default"].cloneElement(children(handleTriggerEvent, a11yAttributes, isOpen), _objectSpread({}, moreProps));
  }

  var commonAttributes = _objectSpread({
    a11yText: a11yText,
    "data-pka-anchor": "popover.trigger"
  }, a11yAttributes);

  if (isEager) {
    return /*#__PURE__*/_react["default"].createElement(sc.Trigger, (0, _extends2["default"])({}, commonAttributes, {
      onMouseOver: handleTriggerEvent,
      onMouseOut: handleTriggerEvent,
      onFocus: handleTriggerEvent,
      onBlur: handleTriggerEvent
    }, moreProps), children);
  }

  return /*#__PURE__*/_react["default"].createElement(_rawButton["default"], (0, _extends2["default"])({}, commonAttributes, {
    onClick: handleTriggerEvent,
    onBlur: shouldKeepFocus ? handleTriggerEvent : null
  }, moreProps), children);
}

Trigger.displayName = "Popover.Trigger";
Trigger.propTypes = propTypes;
Trigger.defaultProps = defaultProps;
var _default = Trigger;
exports["default"] = _default;
//# sourceMappingURL=Trigger.js.map